module.exports = __webpack_public_path__ + "nc_static/media/back_arrow.b933909f.svg";